import { ListItem } from './ListItem/ListItem';
import { selectThirdMenu } from '../../../../../../redux/menu/menuSelectors';
import { FC } from 'react';
import { useTypedSelector } from '../../../../../../redux/hooks';

type BatteriesListProps = {
  handleClick: (newOpen: boolean) => void;
}

export const BatteriesList: FC<BatteriesListProps> = ({ handleClick }) => {
  const isThirdMenuOpen = useTypedSelector(selectThirdMenu);

  const closeSubDrawer = (newOpen: boolean) => {
    if (isThirdMenuOpen) {
      return handleClick(newOpen);
    }
  };

  return (
    <ul onClick={() => closeSubDrawer(false)}>
      <ListItem page="/batteries-18650" title="18650" />
      <ListItem page="/batteries-21700" title="21700" />
    </ul>
  );
};
